export const formatName = (name: { givenName: string; familyName: string }) => {
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	if (!name) {
		return "";
	}

	return `${name.givenName} ${name.familyName}`.trim();
};

export const reloadPage = (e?: { preventDefault: () => void }) => {
	e?.preventDefault();
	window.location.reload();
};

/**
 * Type guard for non-empty string.
 * @param value - The string to check.
 * @returns True if the string is non-empty, false otherwise.
 */
export const isNonEmpty = (value: string | undefined): value is string => {
	return value !== undefined && value.trim() !== "";
};
